import React, { useEffect, useState } from "react";
import { getPaymentUrl } from "../../actions/redsys";

const PaymentDone = () => {
  const url = "https://sis-t.redsys.es:25443/sis/realizarPago";

  const [ds_SignatureVersion, setSignatureVersion] = useState(null);
  const [ds_MerchantParameters, setMerchantParameters] = useState(null);
  const [ds_Signature, setSignature] = useState(null);

  const getPaymentInfo = async () => {
    const data = await getPaymentUrl();
    setSignatureVersion(data["Ds_SignatureVersion"]);
    setSignature(data["Ds_Signature"]);
    setMerchantParameters(data["Ds_MerchantParameters"]);
    console.log({ data });
  };
  useEffect(() => {}, []);

  return (
    <>
      <button className="btn" onClick={getPaymentInfo}>
        FETCH
      </button>
      <form action={url} method="POST">
        <input type="hidden" name="Ds_SignatureVersion" value={ds_SignatureVersion} />
        <input type="hidden" name="Ds_MerchantParameters" value={ds_MerchantParameters} />
        <input type="hidden" name="Ds_Signature" value={ds_Signature} />

        <button type="submit">Pagar</button>
      </form>
    </>
  );
};

export default PaymentDone;
